import * as React from "react";
import { isMobileDevice, MOBILE_BREAKPOINT } from "../../utils/device";

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean>(() => isMobileDevice());

  React.useEffect(() => {
    const update = () => setIsMobile(isMobileDevice());
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    mql.addEventListener("change", update);
    window.addEventListener("resize", update);
    update();
    return () => {
      mql.removeEventListener("change", update);
      window.removeEventListener("resize", update);
    };
  }, []);

  return isMobile;
}
